import React, { useEffect, useRef, useState } from "react";
import { Languages, Check } from "lucide-react";
import { useI18n, LANGUAGE_OPTIONS } from "@/lib/I18nContext";

export default function LanguagePicker() {
  const { lang, setLang, langLabel } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-picker-toggle"
        title={langLabel}
        className="h-10 md:h-11 px-2 md:px-3 border border-zinc-800 hover:border-[var(--c-lime)] transition-colors flex items-center gap-1.5 text-zinc-300 hover:text-white"
      >
        <Languages size={16} />
        <span className="hidden sm:inline text-[10px] uppercase tracking-widest font-mono-data">
          {lang.toUpperCase()}
        </span>
      </button>
      {open && (
        <div
          data-testid="lang-picker-menu"
          className="bg-[#0A0A0A] border border-zinc-800 shadow-2xl z-50
                     fixed inset-x-2 top-[60px]
                     sm:absolute sm:inset-x-auto sm:left-auto sm:right-0 sm:top-auto sm:mt-2 sm:w-48"
        >
          <ul role="listbox">
            {LANGUAGE_OPTIONS.map((opt) => {
              const active = opt.id === lang;
              return (
                <li key={opt.id}>
                  <button
                    type="button"
                    role="option"
                    aria-selected={active}
                    data-testid={`lang-option-${opt.id}`}
                    onClick={() => { setLang(opt.id); setOpen(false); }}
                    className={`w-full text-left px-4 py-2.5 text-xs flex items-center justify-between gap-3 transition-colors ${
                      active
                        ? "bg-[var(--c-lime)] text-black font-bold"
                        : "text-zinc-300 hover:bg-zinc-900 hover:text-white"
                    }`}
                  >
                    <span>{opt.label}</span>
                    {active && <Check size={14} className="shrink-0" />}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
